export default __webpack_public_path__ + "static/media/check-mark.1c103279.png";